import { FormBuilder } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { Operator } from '../enums/Operator.enum';

export class ConceptSetDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        { name: 'includeStack', type: 'Array<IdNameVO>', defaultValue: [] },
        { name: 'includeOperator', type: Operator, defaultValue: Operator.or },
        { name: 'excludeStack', type: 'Array<IdNameVO>', defaultValue: [] },
        { name: 'excludeOperator', type: Operator, defaultValue: Operator.or },
        { name: 'conceptSet', type: 'IdNameVO' }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}